//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
let d=[[[0,"Type",1,0],[1,"Value",0,"Expression",0]],[[["edges"],"SetEdges",{},1,0],[["number_of_edges"],"GetEdges",{R_:{edges:"Edge[]"}},0,0],[["faces"],"SetFaces",{},1,0],[["number_of_faces"],"GetFaces",{R_:{faces:"Face[]"}},0,0],[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0],[["edgeRefID"],"IsValidEdge",{R_:{isValidEdge:''}},1,0],[["face","numberOfEdges"],"GetValidEdgesOfFace",{R_:{edges:"Edge[]"}},1,0],[["edges","numberOfValidEdges"],"GetValidEdgeList",{R_:{validEdges:"Edge[]"}},1,0]],[]];
SPLM.Features.SheetMetal.BreakCornerBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.BreakCornerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.BreakCornerBuilder.TypeOptions = Object.freeze({
    "Fillet" : "Fillet", "ChamferEqualSetback" : "ChamferEqualSetback"});

export default SPLM;